export default __webpack_public_path__ + "static/media/evo-img.aa76a438.webp";